import { useState } from 'react';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import { Box, InputAdornment } from '@mui/material';
import { RootStyle, SearchStyle } from '../Global/Styling';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

export default function JourneyTemplateToolbar({ filterName, onFilterName }) {
  return (
    <RootStyle
      sx={{
        minHeight: 45,
        borderBottom: '1px solid #eaedf1'
      }}
    >
      <Box>
        <SearchStyle
          value={filterName}
          onChange={onFilterName}
          placeholder="Search Agreement"
          classes={{
            root: 'searchHolder',
            input: 'searchInput'
          }}
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          }
        />
      </Box>
    </RootStyle>
  );
}
